<template>
    <div class="d-flex flex-row flex-wrap justify-content-around align-center" v-if="showContent">
        <div class="flex-1 p-2">
            <UserPanel :industries="listings.industries" :cadtools="listings.cadTools" :countries="listings.countries" :states="listings.states" :initialProfile="userData.profile"></UserPanel>
            <div class="card rounded-0 mb-3">
                <h3 class="card-header">
                    Password Management
                </h3>
                <div class="card-body">
                    <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center">
                            <label class="font-weight-bold">
                                Modify
                            </label>
                            <router-link class="btn btn-dark" :to="`/${instance}/account/changepassword`">Change Password</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-1 p-2">
            <ExportPanel :exportOptions="listings.exportOptions" :initialExportSelections="userData.exportOptions"></ExportPanel>
            <ProfilePanel :hideReferenceLocation="false"></ProfilePanel>
            <PrivacyPanel :privacySettings="listings.consents" :initialPrivacySelections="userData.privacyTerms"></PrivacyPanel>
            <DeletePanel></DeletePanel>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import $ from 'jquery'
    import accountApiClient from '../services/apiServices/accountApiClient'

    import ProfilePanel from '@/components/profile/fusion-profile-panel.vue'
    import DeletePanel from '@/components/profile/delete-panel.vue'
    import ExportPanel from '@/components/profile/export-panel.vue'
    import UserPanel from '@/components/profile/user-panel.vue'
    import PrivacyPanel from '@/components/profile/privacy-panel.vue'

    export default {
        name: 'Profile',
        components: {
            ProfilePanel,
            DeletePanel,
            ExportPanel,
            PrivacyPanel,
            UserPanel
        },
        data() {
            return {
                listings: {
                    industries: [],
                    cadTools: [],
                    countries: [],
                    exportOpions:[],
                    states: [],
                    consents: []
                },
                userData: {}
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            ...mapState({
                instance: state => state.instance
            }),
            showContent() {
                return this.oidcIsAuthenticated;
            },
            enableEdit: function () {
                if (!this.editedProfile)
                    return true;
                else
                    return null;
            }
        },
        methods: {
            GetProfileListings: function () {
                accountApiClient.GetProfileListings().then(response => {
                    if (response.data) {
                        this.listings = response.data;
                    } else {
                        this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Unavailable');
                    }
                }).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Connection Failed');
                });
            },
            GetProfile: async function () {
                await accountApiClient.GetProfileModel().then(response => {
                    if (response.data) {
                        this.userData = response.data;
                    } else {
                        this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Unavailable');
                    }
                }).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Connection Failed');
                });
            }
        },
        mounted: async function() {
            await this.$router.isReady();
            await this.GetProfileListings();
            await this.GetProfile();

            this.$nextTick(() => {
                $('.ul-tooltip').tooltip();
            });
        }
    }
</script>

<style scoped>
    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        cursor: not-allowed;
    }

    .btn-dark.disabled, .btn-dark:disabled, .btn-dark[disabled] {
        color: white;
        background-color: var(--ul-red);
        border-color: var(--ul-red);
        opacity: .65;
    }

    div.d-flex.flex-row .flex-1{
        max-width: 625px;
    }
</style>

